// extracted by mini-css-extract-plugin
export default {"dialog":"InfoDialog_dialog__Btmw-","footerLink":"InfoDialog_footerLink__sCR1N"};